import service from '../httpService';
import router from '@/router';

const vendor = {
    namespaced: true,
    state: {
        vendorList: [],
        vendorSecretKey: '',
        vendorLoader: false
    },
    mutations: {
        setVendorList (state, payload) {
            state.vendorList = payload
        },
        setVendorSecretKey (state, payload) {
            state.vendorSecretKey = payload
        },

    },
    actions: {
        async getVendors ({ commit, dispatch }, payload) {
            try {
                var response = await service.getVendorDetails(payload)
                let uri = window.location.search.substring(1);
                let params = new URLSearchParams(uri);
                if (response.data.stat == "Ok") {
                    commit('setVendorList', await response.data.result)
                    if (response.data.result) {
                        response.data.result.forEach(element => {
                            if (parseInt(element.appId) == parseInt(params.get("appId"))) {
                                commit('setVendorSecretKey', element.apiSecret)
                            }
                        })
                    }
                } else {
                    var toastMsg = response.data.message
                }
            } catch (error) {
                dispatch('unAuthorized', error, {root: true})
            }
        },
        async createVendor ({ state,commit, dispatch }, payload) {
            state.vendorLoader = true
            try {
                var response = await service.createVendor(payload)
                if (response.data.stat == "Ok") {
                    var toastMsg = response.data.message
                    router.push({ name: 'apps' })
                } else {
                    var toastMsg = response.data.message
                }
            } catch (error) {
                dispatch('unAuthorized', error, {root: true})
            }
            state.vendorLoader = false
        },
        async updateVendor ({ commit, dispatch }, payload) {
            try {
                var response = await service.updateVendor(payload)
                if (response.data.stat == "Ok") {
                    var toastMsg = response.data.message
                    router.push('apps')
                    // dispatch('getVendors')
                } else {
                    var toastMsg = response.data.message
                }
            } catch (error) {
                dispatch('unAuthorized', error, {root: true})
            }
        },
        async deleteVendor ({ commit, dispatch }, payload) {
            try {
                var response = await service.deleteVendor(payload)
                if (response.data.stat == "Ok") {
                    var toastMsg = response.data.message
                    router.push('apps')
                } else {
                    var toastMsg = response.data.message
                }
            } catch (error) {
                dispatch('unAuthorized', error, {root: true})
            }
        },
        async reGenerateSecretKey ({ commit, dispatch }, payload) {
            try {
                var response = await service.reGenerateSecretKey(payload)
                if (response.data.stat == "Ok") {
                    var toastMsg = response.data.message
                    dispatch('getVendors')
                    // router.push('apps')
                } else {
                    var toastMsg = response.data.message
                }
            } catch (error) {
                dispatch('unAuthorized', error, {root: true})
            }
        },
    },
    getters: {
        getVendorList: state => state.vendorList,
        getVendorSecretKey: state => state.vendorSecretKey,
    },
}
export default vendor